import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';
import PageSizeSelector from '../../../../presentation/PageSizeSelector';
import NoSearchResults from '../../../../presentation/NoSearchResults';
import Pagination from '../../../../presentation/Pagination';
import PagePositionLabel from '../../../../presentation/PagePositionLabel';
import EditSectionLabel from '../../../../presentation/EditSectionLabel';
import EditSectionInput from '../../../../presentation/EditSectionInput';
import EditSectionDropdown from '../../../../presentation/EditSectionDropdown';
import WholesaleUtilityNumberDeleteDialog from './WholesaleUtilityNumberDelete';
import './css/WholesaleUtilityNumbers.css';

import ReactGrid,
{
  ReactGridHeader,
  ReactGridColumn,
  ReactGridBody,
  ReactGridRowTemplate,
  ReactGridIconCell,
  ReactGridReadOnlyCell,
  ReactGridNoRowsTemplate
} from '../../../../presentation/ReactGrid';

class WholesaleUtilityNumbers extends Component {
  constructor( props ) {
    super( props );
    this.title = 'Wholesale Utility Numbers';
    this.state = {
      row: props.row === undefined ? {} : props.row,
      dataSource: [],
      pageSize: 25,
      mode: 'NORMAL',
      numberDailed: '',
      newRow: { 
        'CD_WS_Utility_Numbers_ID': 0, 
        'WS_Company_ID': 0, 
        'Numdialed': '', 
        'Play_Utility_DNIS': 0, 
        'Utility_DNIS': '' 
      },
      deletedRow: undefined,
      deleteDialogShow: false,
      loading: true,
    };

    this.getData = this.getData.bind( this );
    this.onChangeNumberDialed = this.onChangeNumberDialed.bind( this );
    this.onKeyPressNumDialed = this.onKeyPressNumDialed.bind( this );
    this.onNewUtilityNumber = this.onNewUtilityNumber.bind( this );
    this.onChangeItem = this.onChangeItem.bind( this );
    this.onSaveItem = this.onSaveItem.bind( this );
    this.onCancelItem = this.onCancelItem.bind( this );
    this.onIconClicked = this.onIconClicked.bind( this );

    //Delete Dialog Events
    this.onDeleteDialogCancel = this.onDeleteDialogCancel.bind( this );
    this.onDeleteDialogConfirm = this.onDeleteDialogConfirm.bind( this );
  }

  componentDidMount() { 
    this.getData();
  }

  doLogOff() {
    const { dispatch, auth, history } = this.props;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const { dispatch, bugsnag } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if ( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  getUtilityNumbers( ) { 
    return new Promise( ( resolve, reject ) => { 
      let api = new EtelAPI( 'wholesale/utilitynumbers' );
      const row = this.state.row;
      let parameters = [
        { WS_Company_ID: row.Company_ID }
      ];     
      api.get( parameters ).then( ( results ) => { 
        resolve( results );
      } ).catch( ( exception ) => { 
        reject( exception );
      } );
    } );
  }

  getData() {
    const callbacks = [];

    callbacks.push(
      this.getUtilityNumbers()
    );

    const onException = ( exception ) => {
      this.onHandleException( exception );
    };

    const WHOLESALE_UTILITY_NUMBERS_INDEX = 0;
    Promise.all( callbacks ).then( ( results ) => {
      const wholesaleUtilityNumbers = results[ WHOLESALE_UTILITY_NUMBERS_INDEX ];
      this.setState( { 
        dataSource: wholesaleUtilityNumbers,
        loading: false
      } );
    } ).catch( ( exception ) => { 
      onException( exception );
    } );

  }

  getPageSizeOptions() { 
    let options = [];
    const dataSource = this.state.dataSource;

    if( dataSource === undefined ) {
      return options;
    }

    if( dataSource === null ) {
      return options;
    }
    
    if( dataSource.length >= 25 ) {
      options.push( { value: 25, selected: true } );
    }

    if( dataSource.length >= 50 ) {
      options.push( { value: 50, selected: false } );
    }

    if( dataSource.length >= 75 ) {
      options.push( { value: 75, selected: false } );
    }

    if( dataSource.length >= 100 ) {
      options.push( { value: 100, selected: false } );
    }

    if( dataSource.length >= 500 ) {
      options.push( { value: 500, selected: false } );
    }

    if( dataSource.length >= 1000 ) {
      options.push( { value: 1000, selected: false } );
    }

    return options;
  }

  getPlayUtilityDNISOptions() { 
    let options = [
      {'id':0, 'text':'Do Not Play Utility DNIS'},
      {'id':1, 'text':'Play Utility DNIS (Inclusion)'},
      {'id':2, 'text':'Play Utility DNIS (Exclusion)'}
    ];
    return options;
  }
  
  onChangeNumberDialed( e ) {
    this.setState( { 
      numberDialed: e.target.value
    } );
  }

  onKeyPressNumDialed( key ) {
    if( key === 'enter' && key === 'Enter' ) {
      if( this.state.numberDialed !== '' ) {
        this.getData();
      }
    }
  }

  onNewUtilityNumber( e ) {
    const row = this.state.row;
    let newRow = this.state.newRow;
    newRow.WS_Company_ID = row.Company_ID;
    newRow.Play_Utility_DNIS = row.Play_Utility_DNIS;
    newRow.Utility_DNIS = row.Utility_DNIS;
    this.setState( { 
      mode: 'NEW',
      newRow: newRow
    } );
  }

  onChangeItem( e ) {
    let newRow = this.state.newRow;
    newRow[ e.target.column ] = e.target.value;
    this.setState( { 
      newRow: newRow
    } );
  }

  onValidateNewRow( newRow ) {
    const dataSource = this.state.dataSource;
    if( newRow !== undefined && newRow !== null ) {
      if( dataSource !== undefined && dataSource != null ) {
        if( dataSource.length > 0 ) {
          for( var index = 0; index < dataSource.length; index++ ) {
            const dataRow = dataSource[ 0 ];
            // Check if its a duplicate
            if( dataRow.Numdailed === newRow.Numdialed ) {
              return 'The number dialed that you creating already exists.';
            }
          }
        }
      }
    }
    return '';
  }

  onSaveItem( e ) {
    let dataSource = this.state.dataSource;
    const newRow = this.state.newRow;
    const { bugsnag, dispatch } = this.props;
    let api = new EtelAPI( 'wholesale/utilitynumbers' );
    let alert = new Alerts( bugsnag, dispatch );
    
    let message = this.onValidateNewRow( newRow );

    if( message !== '' ) {
      alert.WARNING( this.title, message, 2500 );
      return;
    }

    api.insert( newRow ).then( ( result ) => { 
      dataSource.unshift( result.data[0] );
      this.setState( { 
        dataSource: dataSource,
        mode: 'NORMAL',
        newRow: { 
          'CD_WS_Utility_Numbers_ID': 0, 
          'WS_Company_ID': 0, 
          'Numdialed': '', 
          'Play_Utility_DNIS': 0, 
          'Utility_DNIS': '' 
        }
      }, () => { 
        alert.SUCCESS( this.title, 'Successfully saved the new utility number.', 2500 );
      } );
    } ).catch( ( exception ) => { 
      this.onHandleException( exception );
    } );
  }

  onCancelItem( e ) {
    this.setState( { 
      mode: 'NORMAL',
      newRow: { 
        'CD_WS_Utility_Numbers_ID': 0, 
        'WS_Company_ID': 0, 
        'Numdialed': '', 
        'Play_Utility_DNIS': 0, 
        'Utility_DNIS': '' 
      }
    } );
  }

  onIconClicked( args ) {
    if( args.iconKey === 'delete' ) {
      this.setState( { 
        deletedRow: args.row,
        deletedRows: undefined,
        deleteDialogShow: true
      } );
    }
  }

  onDeleteDialogCancel( ) {
    this.setState( { 
      deleteDialogShow: false,
      deletedRow: undefined,
      deletedRows: undefined
    } );
  }

  onDeleteDialogConfirm( row ) {
    let { dispatch, bugsnag } = this.props;
    let api = new EtelAPI( 'wholesale/utilitynumbers' );
    let alert = new Alerts( bugsnag, dispatch );
    api.delete( row.CD_WS_Utility_Numbers_ID ).then( ( result ) => { 
      this.setState( {
        deletedRow: undefined,
        deletedRows: undefined,
        deleteDialogShow: false
      }, () => {
        this.getData();
        alert.SUCCESS( this.title, 'Successfully deleted Wholesale Utility Number.', 2500 );          
      } );
    } ).catch( ( exception ) => { 
      this.onHandleException( exception );
    } );
  }
  
  onRenderPageSize() {
    const renderedControls = [];
    if( this.state.dataSource !== undefined ) {
      if( this.state.dataSource.length > 0 ) {
        if( this.state.dataSource.length >= this.state.pageSize ) {
          renderedControls.push(
            <PageSizeSelector options={this.getPageSizeOptions()} onPageSizeChanged={this.onPageSizeChanged} /> 
          );
        }
      }
    }
    return renderedControls;
  }
  
  onRenderHeader() {
    const mode = this.state.mode;
    const renderedControls = [];

    if( mode === 'NORMAL' ) {
      renderedControls.push(
        <span key="wholesale-utility-numbers-field-group-1" className="wholesale-utility-numbers-field-group">
          <EditSectionLabel Text="Number Dialed (Use %)" />
          <EditSectionInput value={this.state.numberDialed} onChange={this.onChangeNumberDialed} onKeyPress={this.onKeyPressNumDialed} />
        </span>
      );        
      renderedControls.push(
        <span key="wholesale-utility-numbers-field-group-2" className="wholesale-utility-numbers-field-group">
          <button className="dialog-save-button" onClick={this.onNewUtilityNumber}>
            New Utility Number
          </button>
        </span>
      );        
    }

    if( mode === 'NEW' ) {
      const newRow = this.state.newRow;
      renderedControls.push(
        <span key="wholesale-utility-numbers-field-group-3" className="wholesale-utility-numbers-field-group">
          <EditSectionLabel Text="Enter Number Dialed" />
          <EditSectionInput columnName="Numdialed" value={newRow.Numdialed} onChanged={this.onChangeItem} />
        </span>
      );
      renderedControls.push(
        <span key="wholesale-utility-numbers-field-group-4" className="wholesale-utility-numbers-field-group">
          <EditSectionLabel Text="Utility DNIS" />
          <EditSectionDropdown columnName="Play_Utility_DNIS" value={newRow.Play_Utility_DNIS} onChanged={this.onChangItem} options={this.getPlayUtilityDNISOptions()} />
        </span>
      );
      renderedControls.push(
        <span key="wholesale-utility-numbers-field-group-5" className="wholesale-utility-numbers-field-group">
          <EditSectionLabel Text="Utility DNIS" />
          <EditSectionInput columnName="Utility_DNIS" value={newRow.Utility_DNIS} onChanged={this.onChangeItem} />
        </span>
      );
      renderedControls.push(
        <span key="wholesale-utility-numbers-field-group-6" className="wholesale-utility-numbers-field-group">
          <button className="dialog-save-button" onClick={this.onSaveItem}>
            Save
          </button>
          <button className="dialog-save-button" onClick={this.onCancelItem}>
            Cancel
          </button>
        </span>
      );        
    }
    return renderedControls;
  }

  onRenderBody() {
    let pageSize = this.state.pageSize;
    const pageTotal = this.state.dataSource === undefined ? 0 : this.state.dataSource.length;
    let spacerWidth = ( pageTotal > pageSize ) ? '33px' : '50px';
    return (
      <ReactGrid 
        tagName="grid" 
        dataSource={this.state.dataSource}
        paging={true}
        pageSize={this.state.pageSize}
        pageIndex={this.state.pageIndex}
        height="57.2vh"
        width="auto"
        onIconClicked={this.onIconClicked}
        loading={this.state.loading}
      >
        <ReactGridHeader tagName="header">
          <ReactGridColumn
            index={0}
            tagName='column' 
            caption='Number Dialed'
            sorted="Numdialed"
            width='200px'
            dataType='string'
          />
          <ReactGridColumn
            index={1}
            tagName='column' 
            caption='Play Utility DNIS'
            sorted="Play_Utility_DNIS"
            width='400px'
            dataType='string'
          />                                  
          <ReactGridColumn
            index={2}
            tagName='column' 
            caption='Utility DNIS'
            sorted="Utility_DNIS"
            width='100px'
            dataType='string'
          />     
          <ReactGridColumn
            index={3}
            tagName='column' 
            caption='Delete'
            width='100px'
            icon='icon-fontello-trash-8'
            tooltip='Delete ALL Matching Rows'
            sorted='icon'
          />                    
          <ReactGridColumn
            index={4}
            tagName='column' 
            width='50px'
          />                                                    
        </ReactGridHeader>
        <ReactGridBody tagName="body">
          <ReactGridRowTemplate tagName='rowTemplate'>
            <ReactGridReadOnlyCell 
              tagName='readOnlyCell'
              column="Numdialed"
              width='200px'
              align='left'
            />
            <ReactGridReadOnlyCell 
              tagName='readOnlyCell'
              column="Play_Utility_DNIS_Description"
              width='400px'
              align='center'
            />        
            <ReactGridReadOnlyCell 
              tagName='readOnlyCell'
              column="Utility_DNIS"
              width='100px'
              align='center'
            />                                
            <ReactGridIconCell 
              tagName='iconCell'
              width='100px'
              align='center'
              icon='icon-fontello-trash-8'
              iconKey='delete'
              iconColor='#BE000E'
            />
            <ReactGridReadOnlyCell 
              tagName='readOnlyCell'
              column=""
              width={spacerWidth}
              align='left'
            />                          
          </ReactGridRowTemplate>  
          <ReactGridNoRowsTemplate tagName='noRowTemplate' height='50px'>
            <NoSearchResults caption='There are no utility number records' />
          </ReactGridNoRowsTemplate>          
        </ReactGridBody>
      </ReactGrid>  
    );
  }

  onRenderFooter() {
    let pageSize = this.state.pageSize;
    const pageStart = ( parseInt( this.state.pageIndex, 10 ) * parseInt( pageSize, 10 ) ) + 1;
    const pageEnd = pageStart + parseInt( pageSize, 10 ) - 1;
    const pageTotal = this.state.dataSource === undefined ? 0 : this.state.dataSource.length;
    let renderedControls = [];
    
    renderedControls.push( 
      <span key="leadgen-numbers-in-group-footer-cell-1" className="leadgen-numbers-in-group-footer-cell-1">
        <PagePositionLabel pagesize={pageSize} pagestart={pageStart} pageend={pageEnd} pagetotal={pageTotal} />
      </span>
    );

    renderedControls.push(
      <span key="leadgen-numbers-in-group-footer-cell-2" className="leadgen-numbers-in-group-footer-cell-2">
        <Pagination pageindex={this.state.pageIndex} totalitems={pageTotal} maxitemsperpage={this.state.pageSize} maxpages={6} onPageChanged={this.onPageChanged} />
      </span>
    );

    return renderedControls;
  }

  render() { 
    let deleteDialog = '';
    if( this.state.deletedRow !== undefined ) {
      deleteDialog = (
        <WholesaleUtilityNumberDeleteDialog 
          caption='Delete Wholesale Utility Number' 
          message={'Are you sure you want to delete wholesale utility number ' + this.state.deletedRow.Numdialed + '?'}
          show={this.state.deleteDialogShow} 
          onCancel={this.onDeleteDialogCancel} 
          onConfirm={this.onDeleteDialogConfirm} 
          row={this.state.deletedRow}
        />
      );
    }
    return (
      <span className="wholesale-utility-numbers">
        <span className="wholesale-utility-numbers-pagesize">
          {this.onRenderPageSize()}
        </span>
        <span className="wholesale-utility-numbers-header">
          {this.onRenderHeader()}
        </span>
        <span className="wholesale-utility-numbers-body">
          {this.onRenderBody()}
        </span>
        <span className="wholesale-utility-numbers-footer">
          {this.onRenderFooter()}
        </span>
        {deleteDialog}
      </span>
    );
  }      
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( WholesaleUtilityNumbers ) );


// WEBPACK FOOTER //
// ./src/content/wholesale/companies/components/WholesaleUtilityNumbers.js